import { memo } from 'react';
import Lut from '../../common/Effects/Lut';
import Vignette from '../../common/Effects/Vignette';
import { EffectComposer } from '@react-three/postprocessing';

export default memo(function Effects({ effects: {
  before: Before,
  pre: Pre,
  post: Post,
  after: After,
} = {} }) {
  return (
    <>
      { !!Before && <Before /> }
      <EffectComposer>
        { !!Pre && <Pre /> }
        <Vignette />
        <Lut />
        { !!Post && <Post /> }
      </EffectComposer>
      { !!After && <After /> }
    </>
  );
});